module.exports = __webpack_public_path__ + "img/icon-cart.ea610941.svg";